import StatsCardGreenpill from '../../ui/StatsCardGreenpill';
import TrophyIcon from '../../assets/icons/TrophyIcon';
import { useNavigate } from 'react-router-dom';
import Achievment from './Achievment';
import SelectPrimaryPill from './SelectPrimaryPill';
import Modal from '../../ui/Modal';

import MintNFTModal from './MintNFTModal';
import ButtonGreen from './ButtonGreen';
import { formatNumber } from '../../helpers/formatNumber';

import { useImpacts } from '../../hooks/useImpacts';
import MyCollection from './MyCollection';
import CustomToaster from '../../ui/CustomToaster';
import { useHome } from '../../contexts/HomeContext';
import { useEffect, useRef, useState } from 'react';
import GreenpillFAQModal from './GreenpillFAQ';
import { getImpactPointsUnused } from '../../apis/geenpills/getImpactPointsUnused';
import { useLoadingState } from '../../hooks/useLoader';
import { getGreenpillLeaderboard } from '../../apis/geenpills/greenpillLeaderboard';
import { extraIPsNotification, getNotificationNumber } from '../../helpers/greenPillHelper';
import ButtonNew from '../../ui/ButtonNew';

const UpperLeftGreenpillSection = ({ pillDetails }) => {
    const navigate = useNavigate();
    const [impactPointsUnused, setImpactPointsUnused] = useState(0);
    const {
        loading: gettingPoints,
        startLoading: startGettingPoints,
        stopLoading: stopGettingPoints,
    } = useLoadingState();
    const [myDetails, setMyDetails] = useState({});
    const {
        loading: gettingMyDetails,
        startLoading: startGettingMyDetails,
        stopLoading: stopGettingMyDetails,
    } = useLoadingState();
    const [yourImpacts] = useImpacts();
    const { state: homeState, dispatch, loading } = useHome();

    const { greenPillNFTsHoldByWalletAddress } = homeState;

    useEffect(() => {
        const fetchData = async () => {
            try {
                startGettingMyDetails();
                const response3 = await getGreenpillLeaderboard(undefined, undefined, undefined, undefined, true);

                setMyDetails(response3?.data[0]);
            } catch (error) {
                console.error(error, 'error');
            } finally {
                stopGettingMyDetails();
            }
        };
        fetchData();
    }, []);

    useEffect(function () {
        const fetchData = async () => {
            try {
                startGettingPoints();
                const data = await getImpactPointsUnused();

                setImpactPointsUnused(data?.impactPointsUnused);
            } catch (error) {
                console.log(error);
            } finally {
                stopGettingPoints();
            }
        };
        fetchData();
    }, []);

    const notificationText =
        extraIPsNotification[
        getNotificationNumber(greenPillNFTsHoldByWalletAddress, myDetails?.greenpillCount, homeState?.selectedPill)
        ];

    return (
        <div className="">
            <h1
                className="text-5xl font-semibold text-tPrimary"
                style={{
                    textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                }}
            >
                {'Greenpill  Collection'}
            </h1>
            <p className="text-tSecondary text-sm mt-2 ">
                The Greenpill NFT Collection is a series of mutating NFTs that evolve & grow in value based on real
                world actions!
            </p>

            <div className="flex items-center mt-7  gap-3 mb-5">
                <Modal>
                    <Modal.Button opens={'mint'}>
                        <ButtonGreen
                            w={'w-[12rem]'}
                            name={'Mint New NFT'}
                            icon={'+'}
                            textColor="text-white"
                            iconClassName="text-3xl relative -top-[2px] font-semibold "
                        />
                    </Modal.Button>
                    <Modal.Window name={'mint'}>
                        <MintNFTModal />
                    </Modal.Window>
                </Modal>
                <Modal>
                    <Modal.Button opens={'faq'}>
                        <ButtonNew
                            type="button"
                            fixedMinWidth={true}
                            variant="neutral"

                            size="sm"
                        >
                            <span className="flex items-center gap-2">


                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.625 1.5C5.1075 1.5 2.25 4.3575 2.25 7.875C2.25 11.3925 5.1075 14.25 8.625 14.25H9V16.5C12.645 14.745 15 11.25 15 7.875C15 4.3575 12.1425 1.5 8.625 1.5ZM9.375 12.375H7.875V10.875H9.375V12.375ZM9.67475 8.78904C9.66725 8.79654 9.65975 8.81154 9.65225 8.82654C9.61475 8.88654 9.57725 8.94654 9.54725 9.00654C9.53225 9.02904 9.52475 9.05904 9.51725 9.08904C9.49475 9.14154 9.47225 9.19404 9.45725 9.24654C9.40475 9.40404 9.38225 9.56904 9.38225 9.75654H7.87475C7.87475 9.37404 7.93475 9.05154 8.02475 8.78154C8.02475 8.77404 8.02475 8.76654 8.03225 8.75904C8.03975 8.72904 8.06225 8.71404 8.06975 8.68404C8.11475 8.56404 8.16725 8.45904 8.23475 8.35404C8.25725 8.31654 8.28725 8.27904 8.30975 8.24154C8.33225 8.21154 8.34725 8.17404 8.36975 8.15154L8.37725 8.15904C9.00725 7.33404 10.0348 7.07904 10.1173 6.14904C10.1848 5.41404 9.65975 4.70154 8.93975 4.55154C8.15975 4.38654 7.45475 4.84404 7.21475 5.51154C7.10975 5.78154 6.86225 5.99904 6.55475 5.99904H6.40475C5.95475 5.99904 5.62475 5.55654 5.75225 5.12154C6.16475 3.75654 7.52975 2.80404 9.07475 3.02904C10.3423 3.21654 11.3548 4.25904 11.5723 5.52654C11.9023 7.35654 10.3498 7.79904 9.67475 8.78904Z"
                                        fill="#B7B7B7"
                                    />
                                </svg>
                                <span className="mr-[2px] text-tPrimary">FAQs</span>
                            </span>
                        </ButtonNew>

                    </Modal.Button>
                    <Modal.Window name={'faq'}>
                        <GreenpillFAQModal />
                    </Modal.Window>
                </Modal>
            </div>
            {impactPointsUnused > 0 && (
                <div className="mb-4">
                    <CustomToaster
                        // isTop - > true -> if primary pill is green and all other pills are also green => after colon
                        // isRight -> true -> if primary pill is green and all other pills are not green => after colon
                        isTop={
                            greenPillNFTsHoldByWalletAddress.length === 0
                                ? true
                                : greenPillNFTsHoldByWalletAddress?.length === myDetails?.greenpillCount
                                    ? true
                                    : pillDetails?.colour === 'GREEN'
                                        ? true
                                        : false
                        }
                        isRight={
                            greenPillNFTsHoldByWalletAddress.length === 0
                                ? false
                                : !homeState?.selectedPill
                                    ? true
                                    : greenPillNFTsHoldByWalletAddress?.length === myDetails?.greenpillCount
                                        ? false
                                        : pillDetails?.colour === 'GREEN'
                                            ? true
                                            : false
                        }
                        points={formatNumber(impactPointsUnused)}
                        text={notificationText?.text}
                        extraText={notificationText?.extraText}
                    />
                </div>
            )}

            <div className=" flex items-center gap-3 my-5">
                <StatsCardGreenpill label="Greenpills" stats={myDetails?.greenpillCount} loading={gettingMyDetails} />
                <StatsCardGreenpill
                    label="IP unlocked till now"
                    symbol={<TrophyIcon />}
                    stats={
                        myDetails?.totalImpactPoints
                            ? formatNumber(Number(myDetails?.totalImpactPoints))
                            : 0
                    }
                    loading={gettingMyDetails}
                />
                <StatsCardGreenpill
                    label="My Rank"
                    symbol={<p className="text-4xl font-medium ">#</p>}
                    stats={myDetails?.rank}
                    className={'w-40'}
                    onClick={() => navigate('leaderboard')}
                    applyHover={true}
                    loading={gettingMyDetails}
                />
            </div>

            <MyCollection />
        </div>
    );
};

export default UpperLeftGreenpillSection;
// greenPillNFTsHoldByWalletAddress.length > 0 && homeState?.selectedPill && one more condition here that is pill is not green
